<div class="create-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-lavuro m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-manax title-create">
          Crear Nuevo:
        </span>
      </h3>

    </div>
  </div>

<!-- body -->
<div class="m-0 p-0 create-modal-content">
  <div class="row">
    <div class="col-md-12 d-flex justify-content-center">
      <div class="action-btn" (click)="openNewQuoteModal()">
        <i class="material-icons action-icon">request_quote</i>
        <span>Presupuesto</span>
      </div>
      <div class="action-btn" (click)="openNewTaskModal('SCHEDULED')">
        <i class="material-icons action-icon">business_center</i>
        <span>Trabajo</span>
      </div>
      <div class="action-btn" (click)="openNewBDocumentModal()">
        <i class="material-icons action-icon">paid</i>
        <span>Factura</span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 d-flex justify-content-center">
      <div class="action-btn" (click)="openNewClientModal()">
        <i class="material-icons action-icon">face</i>
        <span>Cliente</span>
      </div>
      <div class="action-btn" (click)="openNewWorkerModal()">
        <i class="material-icons action-icon">groups</i>
        <span>Trabajador</span>
      </div>
      <div class="action-btn" (click)="openNewUserModal()">
        <i class="material-icons action-icon">person</i>
        <span>Usuario</span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 d-flex justify-content-center">
      <div class="action-btn-large" (click)="openNewCategoryModal()">
        <i class="material-icons action-icon-large">category</i>
        <span>Categoría de Servicio</span>
      </div>
      <div class="action-btn-large" (click)="openNewProductModal()">
        <i class="material-icons action-icon-large">attach_money</i>
        <span>Producto / Prestación</span>
      </div>
    </div>
  </div>
</div>


</div>